export default __webpack_public_path__ + "static/media/Hair_16_F_C2.609f60ec.svg";